// Współrzędne gry są przechowywane w bazie przemnożone przez stałe z .env
// (REACT_APP_LAT/REACT_APP_LNG) - to nie jest realne zabezpieczenie (mnożniki
// są publiczne w zbudowanym bundlu), tylko dodatkowa warstwa utrudnienia.
// Mnożenie/dzielenie liczb zmiennoprzecinkowych nie jest w 100% odwracalne,
// więc zaokrąglamy wynik do 7 miejsc po przecinku (~1.1 cm precyzji przy
// równiku) - eliminuje to szum z zaokrągleń, zachowując pełną precyzję
// potrzebną w grze.
const DECIMAL_PRECISION = 1e7;

const roundCoordinate = (value: number) =>
  Math.round(value * DECIMAL_PRECISION) / DECIMAL_PRECISION;

export const unscaleLat = (scaledLat: number) =>
  roundCoordinate(scaledLat / Number(process.env.REACT_APP_LAT));

export const unscaleLng = (scaledLng: number) =>
  roundCoordinate(scaledLng / Number(process.env.REACT_APP_LNG));
